module.exports = __webpack_public_path__ + "static/img/4.a2ea82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/4.png
// module id = G7Kk
// module chunks = 35